import Roles from "@/utils/roles"
import { isInRoles } from "@/utils/authorize.directive"

export default [
    {
        path: "/leads-self-service",
        name: "leads-self-service",
        component: () => import("@/views/area-mention/leads-self-service/index.vue"),
        meta: {
          title: 'Leads do self-service',
          authRequired: true,
          roles: [Roles.CommercialSelfServiceLeads]
        },
        // The global `meta.roles` check is still commented out in the router, so hiding the
        // menu entry alone would leave the URL reachable by typing it.
        beforeEnter: (to, from, next) => {
          if (!isInRoles(Roles.CommercialSelfServiceLeads)) {
            next({ name: 'home' })
            return
          }
          next()
        },
    },
];
